import React from 'react';
export const Record2Fill = props => (
  <svg viewBox="0 0 20 20" width="16px" height="16px" {...props} className={`btfont ${props.className ? props.className : ''}`}><path d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" fillRule="evenodd" />,
<path d="M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10zm0-2a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" fillRule="evenodd" /></svg>
);
